import React from "react";
import Sidebar from "components/Sidebar";
import { stepsByName } from "../specificUtils/configs";

export default function SidebarWrapper(props) {
  return (
    <Sidebar
      packageTitle="Seleziona periodo 2024"
      structureTitle="Sistemazione scelta"
      contributoInpsLabel=""
      enableTagManager
      onNext={props.onNext}
      sendBookingButtonLabel={props.sendBookingButtonLabel}
      isSubmitting={props.isSubmitting}
      stepsByName={stepsByName}
    />
  );
}
